import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@zhfe/common-library'
import { RANK_URL } from '@/common/config'

export interface Classify {
  /** 分类id */
  classify_id: number
  /** 分类名称	*/
  classify_name: string
  /** 分类等级	*/
  classify_level: number
  /** 1级分类名称 */
  cat1_name: string
  /** 2级分类名称 */
  cat2_name: string
  /** 0 禁用 1启用 */
  status: number
  /** 排序值	*/
  order_num: number
  /** 创建时间	*/
  create_time: string
  /** 更新时间	*/
  update_time: string
}

export interface ClassifyList {
  list: Classify[]
}

export interface QuerySortParams {
  /** 分类排序唯一标识	*/
  id?: number
  /** 排序列表标识 */
  custom_mat_sort_id?: number
  /** 分类标识 */
  cat?: number
}

export interface QueryClassifyParams {
  /** 起始页数	*/
  page: number
  /** 页容量	*/
  page_size: number
  /** 上下线状态，0 禁用 1启用,搜索筛选项 */
  status: number
}

export interface AddCatSortParams {
  /** 排序列表标识 */
  custom_mat_sort_id?: number
  /** 分类标识	*/
  cat?: number
  /** 素材排序	*/
  mat_sort?: string
}

export interface DeleteCatSortParams {
  /** 分类排序标识	*/
  id: number
}

export interface UpdateCatSortParams {
  /** 分类排序标识	*/
  id?: number
  /** 排序列表标识 */
  custom_mat_sort_id?: number
  /** 分类标识	*/
  cat?: number
  /** 素材排序	*/
  mat_sort: string
}

export interface CatMatSortItem {
  /** 分类排序唯一标识 */
  id?: number
  /** 排序列表标识 */
  custom_mat_sort_id?: number
  /** 分类标识 */
  cat: number
  /** 分类列表 */
  mat_sort: string
  /** 创建时间 */
  create_time?: string
  /** 更新时间	*/
  update_time?: string
}

export interface CatSortList {
  list: CatMatSortItem[]
  total: number
}

export interface MatFiles {
  /** 格式 **/
  format: string
  /** 大小 **/
  size: number
  /** 页数 **/
  page_count: number
  /** 文件链接 **/
  file_url: string
}

export interface MatsList {
  /** 模板id **/
  id: number
  /** 设计师id **/
  designer_id: number
  /** 上传时间 **/
  upload_time: string
  /** 标题 **/
  title: string
  /** 标签 **/
  tag: string
  /** 场景数据 1：web 2：duba 3：ppt 4：liebao 5：pdf **/
  scene?: number[]
  /** 模板状态 0：已下架 1：已上架 2：待审核 3：已驳回**/
  status?: string
  /** 支付类型 0：免费 1：付费 **/
  pay_type?: string
  /** 小图地址 **/
  small_img: string
  /** 大图地址 **/
  big_img: string
  /** 大图地址列表 **/
  big_imgs: string[]
  /** 大图类型：0未知，1拼图，2单图 */
  big_img_type: number
  /** 大图排版方式：0未知，1横向，2纵向 */
  big_img_layout: number
  /** 一级分类id **/
  class_1?: number
  /** 二级分类id **/
  class_2?: number
  /** 三级分类id **/
  class_3?: number
  /** 多个格式 **/
  mat_files?: MatFiles[],
  preview_video?: string
}

export interface MatsManageResponseData {
  list: MatsList[],
  total: number
}

export interface ClassifyLableValue {
  value: number
  label: string
}

export interface MatConfig {
  order: string
  matId: string
  title: string
}

@Injectable()
export class ConfigService {
  constructor(private http: Http) {}

  /** 查询分类素材排序 */
  queryCatSortList (params: QuerySortParams) {
    return this.http.post<CatSortList>('/cat_mat_sort/list', params).then((response: CatSortList) => {
      return { list: response.list }
    })
  }

  /** 查询分类列表 */
  queryClassifyList (params: QueryClassifyParams) {
    return this.http.post('/classify/search', params).then((res) => {
      return { list: res.list }
    })
  }

  /** 添加分类素材排序 */
  addClassifySort (params: AddCatSortParams) {
    return this.http.post('/cat_mat_sort/add', params)
  }

  /** 更新分类素材排序 */
  updateClassifySort (params: UpdateCatSortParams) {
    return this.http.post('/cat_mat_sort/update', params).then((res) => {
      return res
    })
  }

  /** 删除分类素材排序 */
  deleteClassifySort (params: DeleteCatSortParams) {
    return this.http.post('/cat_mat_sort/delete', params)
  }

  getMatTitleById(id: number) {
    if (id) {
      const req = {
        page: 1,
        size: 1,
        id: id
      }
      return this.http.post('/manager/mats', req)
        .then((response: MatsManageResponseData) => {
          if (response.list.length > 0) {
            return response.list[0].title
          }
          return ''
        })
    }
    return Promise.resolve('')
  }

  getAllClassifyList() {
    const params = {
      page: 1,
      page_size: 1000,
      status: 1
    }
    return this.queryClassifyList(params)
      .then<ClassifyLableValue[]>((res: ClassifyList) => {
        return res.list.map((item: Classify) => {
          return {
            value: item.classify_id,
            label: item.classify_name
          }
        })
      })
  }

  cdnAndCacheRefresh ({ product, classId }: { product: string, classId: string }) {
    return this.http.get(`${RANK_URL}/mat/ranking/one?product=${product}&class=${classId}`, {})
  }
}
